import React from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

// material-ui
import CircularProgress from "@material-ui/core/CircularProgress"
import withStyles from "@material-ui/core/styles/withStyles"
import styles from "./styles"

function getButtonClass(type, classes) {
    return {
        primary: classes.primary,
        secondary: classes.secondary,
        complete: classes.complete,
        contrast: classes.contrast,
        login: classes.login,
        resetPassword: classes.resetPassword,
    }[type]
}

export const Button = (props) => {
    const {
        children, classes, type, loader, disabled, onClick, component, className, noSubmit, buttonRef, ...other
    } = props
    const Component = component
    return (
        <Component
            {...other}
            onClick={onClick}
            className={classNames(getButtonClass(type, classes), className)}
            disabled={disabled}
            type={noSubmit ? "button" : "submit"}
            ref={buttonRef}
        >
            {children}
            {loader && (
                <CircularProgress className={classes.loader} size={17} style={{ top: "calc(50% - (17px / 2))" }} color="inherit" />
            )}
        </Component>
    )
}

Button.propTypes = {
    component: PropTypes.node,
    classes: PropTypes.object.isRequired,
    children: PropTypes.node,
    loader: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    type: PropTypes.oneOf([
        "primary",
        "secondary",
        "complete",
        "contrast",
        "login",
        "resetPassword",
    ]),
    onClick: PropTypes.func,
    noSubmit: PropTypes.bool,
}

Button.defaultProps = {
    component: "button",
    children: null,
    loader: false,
    disabled: false,
    noSubmit: false,
    className: "",
    type: "primary",
    onClick: null,
    buttonRef: null,
}

export default withStyles(styles)(Button)
